import { getLocale, type AppLocale } from "@airange/shared/i18n-redblue-admin";
import { createLocaleController } from "@airange/shared/locale";
import { getStoredAppLocale, setStoredAppLocale } from "@airange/shared/locale-storage";
import { setLocale as setUmiLocale } from "@@/plugin-locale";

function toUmiLocale(locale: AppLocale) {
  if (locale === "en") return "en-US";
  if (locale === "ja") return "ja-JP";
  return "zh-CN";
}

const baseLocaleController = createLocaleController({
  getStoredLocale: () => getStoredAppLocale(),
  setStoredLocale: (locale) => setStoredAppLocale(locale),
});

const localeController = {
  ...baseLocaleController,
  initializeLocale: () => {
    const locale = baseLocaleController.initializeLocale();
    setUmiLocale(toUmiLocale(locale), false);
    return locale;
  },
  switchLocale: (locale: string) => {
    const nextLocale = baseLocaleController.switchLocale(locale);
    setUmiLocale(toUmiLocale(nextLocale), false);
    return nextLocale;
  },
};

export const redblueAdminLocaleController = localeController;

let initialized = false;

export function initializeRedblueAdminLocale() {
  if (initialized) {
    return getLocale();
  }
  initialized = true;
  return localeController.initializeLocale();
}
